module.exports = __webpack_public_path__ + "img/Certificate_15.45729640.jpg";